import React from 'react';

// Ambient lavender + drifting color-blob background used across all auth pages.
export default function BlobField() {
  return (
    <div className="blob-field" aria-hidden="true">
      <div className="blob b1" />
      <div className="blob b2" />
      <div className="blob b3" />
      <div className="blob b4" />
    </div>
  );
}
